import React, { useState, useEffect, useContext } from 'react';
import { FirebaseContext2 } from '../../../../../../firebase';
import { TdpkEnergySavingComponents } from '../../../../components/TDPK';

const TdpkEnergySavingContainer = () => {
  const firebase = useContext(FirebaseContext2);
  const [energySaving, setEnergySaving] = useState(null);

  function fetchData(didMount) {
    const main_path = 'hotel/mintel/energy/energy_saving_recommendation';

    if (didMount) {
      firebase.db.ref(main_path).off('value');
    } else {
      firebase.db.ref(main_path).on('value', function (snap) {
        let capt = snap.val();
        setEnergySaving(capt);
      });
    }
  }

  useEffect(() => {
    fetchData(false);
    return () => fetchData(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const plotData = {
    series: [
      {
        name: 'Your consumption',
        data: energySaving !== null ? Object.values(energySaving.power_consumption) : [],
        type: 'area',
      },
      {
        name: 'Altotech Solution',
        data: energySaving !== null ? Object.values(energySaving.alto_saving_kw) : [],
        type: 'area',
      },
    ],
    options: {
      chart: {
        type: 'area',
        stacked: false,
        height: 350,
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      fill: {
        type: 'area',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.45,
          opacityTo: 0.05,
          stops: [20, 100, 100, 100],
        },
      },
      yaxis: {
        tickAmount: 9,
        title: {
          text: '(kW)',
        },
        formatter: function (val) {
          return val.toFixed(2);
        },
      },
      xaxis: {
        type: 'category',
        categories: energySaving !== null ? Object.keys(energySaving.power_consumption) : [],
      },
      title: {
        text: 'Irregular Data in Time Series',
        align: 'left',
        offsetX: 14,
      },
      tooltip: {
        shared: true,
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        offsetX: -10,
      },
    },
  };
  return (
    <div>
      <TdpkEnergySavingComponents
        title={'Energy saving recommendation'}
        plotData={plotData}
        energySaving={energySaving}
      />
    </div>
  );
};

export { TdpkEnergySavingContainer };
